import { useState } from "react";
import { useSendSupportMutation } from "../../services/store/api/supportApi";
import Loader from "../../components/loader/loader";
import styles from "./help.module.css";
import Heading from "../../components/heading/heading";

export function HelpPage() {
  const [message, setMessage] = useState("");
  const [send, { isLoading, isSuccess, isError }] = useSendSupportMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!message.trim()) return;
    await send({ message: message.trim() });
    setMessage("");
  };

  return (
    <>
      <Heading tpl="new">Помощь</Heading>
      <div className={styles.wrapper}>
        <div className={styles.card}>
          <div className={styles.title}>Расскажите, что случилось</div>
          <p className={styles.desc}>Опишите проблему или вопрос. Мы ответим в ближайшее время.</p>
          <form className={styles.form} onSubmit={handleSubmit}>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Ваше сообщение"
              maxLength={4000}
              className={styles.textarea}
              required
            />
            <div className={styles.footer}>
              <span className={styles.counter}>{message.length}/4000</span>
              <button type="submit" className={styles.submit} disabled={isLoading || !message.trim()}>
                {isLoading ? <Loader tpl="small" /> : "Отправить"}
              </button>
            </div>
          </form>
          {isSuccess && <div className={styles.success}>Сообщение отправлено</div>}
          {isError && <div className={styles.error}>Не удалось отправить. Попробуйте позже.</div>}
        </div>
      </div>
    </>
  );
}

export default HelpPage;
